import { AxiosResponse } from "axios";
import { PagedResponse } from "models/paged-response";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { createComplaintFailed, createComplaintRequest, createComplaintSuccess } from "store/modules/complaints/actions/createComplaint";
import { getComplaintByIdFailed, getComplaintByIdRequest, getComplaintByIdSuccess } from "store/modules/complaints/actions/getComplaintById";
import { getComplaintsGeojsonFailed, getComplaintsGeojsonRequest, getComplaintsGeojsonSuccess } from "store/modules/complaints/actions/getComplaintsGeojson";
import { getComplaintsPaginatedFailed, getComplaintsPaginatedRequest, getComplaintsPaginatedSuccess } from "store/modules/complaints/actions/getComplaintsPaged";
import { getComplaintTypesFailed, getComplaintTypesRequest, getComplaintTypesSuccess } from "store/modules/complaints/actions/getComplaintTypes";
import { sentCommentFailed, sentCommentRequest, sentCommentSuccess } from "store/modules/complaints/actions/sentComment";
import { ComplaintDetail, CreateComplaintRequest, GetComplaintByIdRequest, GetComplaintsGeojsonRequest, GetComplaintsPaginatedRequest, GetComplaintTypesRequest, SentCommentRequest } from "store/modules/complaints/types";
import api from "_config/api";

function* getComplaintsPaginated(params: {
    type: string;
    payload: GetComplaintsPaginatedRequest;
}) {
    try {
        const response: AxiosResponse<PagedResponse<any>> = yield call(
            api.get,
            `manifestacoes/paginated`,
            {
                params: {
                    pageIndex: params.payload.index,
                    pageSize: params.payload.pageSize,
                    dataInicio: params.payload.startDate ? params.payload.startDate : undefined,
                    dataFim: params.payload.endDate ? params.payload.endDate : undefined,
                    status: params.payload.complaintStatus,
                    search: params.payload.search
                }
            }
        );

        yield put(getComplaintsPaginatedSuccess(response.data));
    } catch (error) {
        yield put(getComplaintsPaginatedFailed([]));
    }
}

function* getComplaintById(params: {
    type: string;
    payload: GetComplaintByIdRequest;
}) {
    try {
        const response: AxiosResponse<ComplaintDetail> = yield call(
            api.get,
            `manifestacoes/detalhe/${params.payload.complaintId}`
        );

        yield put(getComplaintByIdSuccess(response.data));
    } catch (error) {
        yield put(getComplaintByIdFailed([]));
    }
}

function* sentComment(params: {
    type: string;
    payload: SentCommentRequest;
}) {
    try {
        const response: AxiosResponse<any> = yield call(
            api.post,
            `manifestacoes/mensagem/${params.payload.complaintId}`,
            { texto: params.payload.texto }
        );

        yield put(sentCommentSuccess(response.data));
        params.payload.onSuccess?.();
    } catch (error) {
        yield put(sentCommentFailed([]));
        params.payload.onFailed?.(error);
    }
}

function* getComplaintTypes(params: {
    type: string;
    payload: GetComplaintTypesRequest;
}) {
    try {
        const response: AxiosResponse<any> = yield call(
            api.get,
            `manifestacoes/tiposManifestacoes`
        );

        yield put(getComplaintTypesSuccess(response.data));
    } catch (error) {
        yield put(getComplaintTypesFailed([]));
    }
}

function* getComplaintsGeojson(params: {
    type: string;
    payload: GetComplaintsGeojsonRequest;
}) {
    try {
        const response: AxiosResponse<any> = yield call(
            api.get,
            `manifestacoes/geojson${params.payload.showOnlyUser ? '/user' : ''}`
        );

        yield put(getComplaintsGeojsonSuccess(response.data));
    } catch (error) {
        yield put(getComplaintsGeojsonFailed([]));
    }
}

function* createComplaint(params: {
    type: string;
    payload: CreateComplaintRequest;
}) {
    try {
        const data = {
            titulo: params.payload.titulo,
            descricao: params.payload.descricao,
            tipoManifestacao: params.payload.tipoManifestacao,
            latitude: params.payload.latitude,
            longitude: params.payload.longitude,
        }
        const response: AxiosResponse = yield call(
            api.post,
            `/manifestacoes`,
            data
        );
        const formData = new FormData();
        formData.append('Anexo', params.payload.imagem);
        yield call(
            api.post,
            `/manifestacoes/arquivo/${response.data.idManifestacao ?? response.data.idPontoEssencial}`,
            formData
        );

        yield put(createComplaintSuccess(null));
        params.payload.onSuccess?.();        
    } catch (error) {
        yield put(createComplaintFailed([]));
        params.payload.onFailed?.();
    }
}

export default all([
    takeLatest(getComplaintsPaginatedRequest.type, getComplaintsPaginated),
    takeLatest(getComplaintByIdRequest.type, getComplaintById),
    takeLatest(getComplaintTypesRequest.type, getComplaintTypes),
    takeLatest(getComplaintsGeojsonRequest.type, getComplaintsGeojson),
    takeLatest(sentCommentRequest.type, sentComment),
    takeLatest(createComplaintRequest.type, createComplaint),
]);
